// extracted by mini-css-extract-plugin
export default {"cards__wrapper_img":"Card_cards__wrapper_img__7grXZ","cards__wrapper_title":"Card_cards__wrapper_title__phpMp","cards__wrapper_description":"Card_cards__wrapper_description__2+MwK"};